import { useState } from "react";
import gql from "graphql-tag";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import useUserStore from "../../store/userStore";
import { enqueueSnackbar } from "notistack";
import useConsentStore, { ConsentType, EmailVerifiedState } from "../../store/consentStore";
import { useMutation } from "@apollo/client";
import useUpdateConsentOwnHands from "../../hooks/useUpdateConsentOwnHands";
import { useCompanySelection } from "../../hooks/useCompanySelection";

const DELETE_CONSENT_ONLINE_CONTACT_INFO = gql`
  mutation DeleteConsentOnlineContactInfo($ico: String!) {
    deleteConsentOnlineContactInfo(ico: $ico)
  }
`;

const CancelConsent = () => {
  const {
    setHasConsentOnline,
  } = useUserStore();

  const {
    getSelectedConsentOnline,
    getSelectedConsentOwnHands,
  } = useConsentStore();

  const { selectedIco } = useCompanySelection();

  // Get data from selected company
  const selectedConsentOnline = getSelectedConsentOnline();
  const selectedConsentOwnHands = getSelectedConsentOwnHands();
  const consentOnlineDeletedAt = selectedConsentOnline?.deletedAt;
  const consentOwnHandsText = selectedConsentOwnHands?.text;

  const [open, setOpen] = useState(false);

  const { updateConsent } = useUpdateConsentOwnHands();

  const [deleteConsentOnlineContactInfo, {
    error: deleteConsentOnlineContactInfoError,
  }] = useMutation(DELETE_CONSENT_ONLINE_CONTACT_INFO, {
    refetchQueries: "all",
  });

  const handleClose = () => {
    setOpen(false);
  };

  const handleDeleteConsentOnlineContactInfo = () => {
    if (!selectedIco) {
      enqueueSnackbar('Chybí identifikace společnosti', { variant: 'error' });
      return;
    }
    deleteConsentOnlineContactInfo({ variables: { ico: selectedIco } });
    if (deleteConsentOnlineContactInfoError) {
      enqueueSnackbar('Nelze zrušit souhlas', { variant: 'error' });
      return;
    }
  };

  const handleConsentWithdrawal = () => {
    if (!consentOwnHandsText?.id) {
      handleDeleteConsentOnlineContactInfo();
      enqueueSnackbar('Údaje byly smazány', { variant: 'success' });
      setOpen(false);
    } else {
      handleDeleteConsentOnlineContactInfo();
      setOpen(false);
      setHasConsentOnline(false);
      updateConsent(consentOwnHandsText.id, ConsentType.WITHDRAWAL);
    }
  };

  return (
    <>
      <Button
        disabled={
          consentOnlineDeletedAt !== null
        }
        variant="outlined"
        disableElevation
        color="primary"
        onClick={() => setOpen(true)}
      >
        Smazat údaje a odvolat souhlas
      </Button>

      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>
          Opravdu chcete zrušit a odvolat souhlas?
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Opravdu chceš zrušit souhlas a připravit se o výhody elektronické komunikace.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConsentWithdrawal}>Ano</Button>
          <Button onClick={handleClose} autoFocus>
            Ne
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CancelConsent;
